import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import Footer from '../Components/Footer/Footer';
import Header from '../Components/Header/Header';
import MainRoutes from '../Components/Main/MainRoutes';
import '../Styles/App.scss'

function App() {
  return (
    <div className="wrapper-app">
      <BrowserRouter>
        <Header />
        <MainRoutes/>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;